import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-location-white',
  templateUrl: './icon-location-white.component.html',
  styles: []
})
export class IconLocationWhiteComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
